<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <el-form :model="value" ref="formRef" :rules="rules">
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接地址" prop="host" required>
          <el-input v-model="value.host" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接端口" prop="port" required>
          <el-input v-model="value.port" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="队列管理器名称" prop="queueManager" required>
          <el-input v-model="value.queueManager" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="编码字符集(CCSID)" prop="ccsid" required>
          <el-input v-model="value.ccsid" />
        </el-form-item>
      </el-col>
      <el-col :lg="24" :sm="12">
        <el-form-item label="服务器连接通道名称" prop="channel" required>
          <el-input v-model="value.channel" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接用户名" prop="username">
          <el-input v-model="value.username" />
        </el-form-item>
      </el-col>
    <el-col :lg="12" :sm="12">
      <el-form-item label="连接密码" prop="password" >
        <el-input v-model="value.password" show-password/>
      </el-form-item>
    </el-col>
    <el-col :lg="24" :sm="12">
      <el-form-item label="发送至节点队列名称" prop="outqueue" outqueue>
        <el-input v-model="value.outqueue" />
      </el-form-item>
    </el-col>
    <el-col :lg="24" :sm="12">
      <el-form-item label="从节点接收队列名称" prop="inqueue" inqueue>
        <el-input v-model="value.inqueue" />
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import CommonValidate from "@/libs/Validate";

  export default {
    name: "IBMMQConfig",
    components: {},
    computed: {},
    props:{
      value:{}
    },
    data() {
      return {
        rules: {
          host: [{ required: true, message: "这是必填字段" },{min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          port: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          queueManager: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          channel: [{ required: true, message: "这是必填字段" },
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          ccsid: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {validator: CommonValidate.checkNumber, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          inqueue: [{ required: true, message: "这是必填字段" },
            {min: 1, max: 50, message: "长度在 1 到 50 个字符以内", trigger: "blur"}],
          outqueue: [{ required: true, message: "这是必填字段" },
            {min: 1, max: 50, message: "长度在 1 到 50 个字符以内", trigger: "blur"}],
        },
      };
    },
    async mounted() {
    },
    methods: {
      validate() {
        return this.$refs.formRef.validate();
      }
    },
  };
</script>
